import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    backgroundColor: theme.palette.secondary.light,
  },
  container: {
    marginTop: theme.spacing(15),
    marginBottom: theme.spacing(30),
    display: 'flex',
    position: 'relative',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 5),
  },
  image: {
    height: 55,
  },
  title: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  curvyLines: {
    pointerEvents: 'none',
    position: 'absolute',
    top: -180,
  },
});

function ProductValues(props) {
  const { classes , language } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <img
          src="/static/productCurvyLines.png"
          className={classes.curvyLines}
          alt="curvy lines"
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={6} lg={3} >
            <div className={classes.item}>
              <img
                className={classes.image}
                src="/static/shield.svg"
                alt="secure environment"
              />
              <Typography variant="h6" className={classes.title}>
                {language==="en-US"?"Secure":"Terlindungi"}
              </Typography>
              <Typography variant="h5">
                {language==="en-US"?
                'We are using the latest and layered security system for securing your data transactoions.'+
                ' Beside using SSL encryption on https protocol, we are also using TLS and data rules system.'
                :
                'Kami menggunakan sistem keamanan terbaru dan berlapis untuk mengamankan data transaksi Anda.'+
                ' Selain terenkripsi menggunakan SSL di protokol https, Kami juga menggunakan TLS dan data rules system.'
                }
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={3} >
            <div className={classes.item}>
              <img
                className={classes.image}
                src="/static/global.svg"
                alt="arround the world"
              />
              <Typography variant="h6" className={classes.title}>
                {language==="en-US"?"Cross Platform":"Jangkauan Luas"}
              </Typography>
              <Typography variant="h5">
                {language==="en-US"?
                'Accesses from around the world.'+
                ' Simply install Google Chrome then it can be accessed on Android, IOS and Windows computers'
                :
                'Online dan bisa diakses dimanapun Anda berada.'+
                ' Cukup pasang Google Chrome maka bisa diakses di Android, IOS dan komputer Windows'
                }
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={3} >
            <div className={classes.item}>
              <img
                className={classes.image}
                src="/static/easy.svg"
                alt="easy to use"
              />
              <Typography variant="h6" className={classes.title}>
                {language==="en-US"?"Easy to Use":"Mudah Digunakan"}
              </Typography>
              <Typography variant="h5">
                {language==="en-US"?
                'Designed for simplicity and aesibility.'+
                ' Even though unexperienced operator can operate this system.'
                :
                'Dirancang dengan tampilan sederhana sehingga mudah digunakan.'+
                ' Walaupun bagi operator awam sekalipun tetap bisa mengoperasikan sistem ini.'
                }
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={3} >
            <div className={classes.item}>
              <img
                className={classes.image}
                src="/static/dollar.svg"
                alt="free"
              />
              <Typography variant="h6" className={classes.title}>
                {language==="en-US"?"FREE":"GRATIS"}
              </Typography>
              <Typography variant="h5">
                {language==="en-US"?
                'This is free to use for start up company and non profit company.'+
                ' But you can upgrade further more to enterprise feature for your convenience.'
                :
                'Sistem Kami bebas digunakan untuk usaha non profit dan juga bagi Anda yang sedang merintis usaha baru.'+
                ' Tetapi kedepannya Anda juga bisa membeli beberapa fitur tambahan sesuai kebutuhan Anda.'
                }
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

ProductValues.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductValues);